export const apiRoutes = {
    assets: {
        robots: {
            main: {
                route: '/robots.txt',
                get: () => `/robots.txt`,
            },
        },
        ads: {
            main: {
                route: '/ads.txt',
                get: () => `/ads.txt`,
            },
        },
        favicon: {
            main: {
                route: '/favicon.ico',
                get: () => `/favicon.ico`,
            },
        },
    },
    main: {
        route: '/api',
        get: () => '/spi',
    },
    graphql: {
        main: {
            route: '/graphql',
            get: () => `/graphql`,
        },
    },
    sitemap: {
        main: {
            route: '/sitemap.xml',
            get: () => `/sitemap.xml`,
        },
    },
    stripe: {
        main: {
            route: '/api/stripe',
            get: () => '/spi/stripe',
        },
        credits: {
            createCheckoutSession: {
                route: '/api/stripe/credits/createCheckoutSession/:credit_id',
                get: (credit_id, redirect_url_success, redirect_url_cancel) => `/api/stripe/credits/createCheckoutSession/${credit_id}?redirect_url_success=${encodeURIComponent(redirect_url_success)}&redirect_url_cancel=${encodeURIComponent(redirect_url_cancel)}`,
            },
        },
        webhook: {
            route: '/api/stripe/webhook',
            get: () => '/api/stripe/webhook',
        },
        sessionRedirect: {
            route: '/api/stripe/sessionRedirect/:checkout_session_id',
        },
        customerPortal: {
            route: '/api/stripe/customerPortal/:token',
            get: ({ return_url, customer_portal_token }) => `/api/stripe/customerPortal/${customer_portal_token}?return_url=${return_url}`,
        },
    },
    mux: {
        main: {
            route: '/api/mux',
            get: () => '/spi/mux',
        },
        webhook: {
            route: '/api/mux/webhook',
            get: (return_url) => `/api/mux/webhook?return_url=${return_url}`,
        },
    },
    instagram: {
        webhook: {
            callback: {
                route: '/api/instagram/webhook/callback-url',
                get: () => '/api/instagram/webhook/callback-url',
            },
        },
    },
};
//# sourceMappingURL=api.js.map